import { VisitLocationData, VisitLocationId, VisitLocationType } from './VisitLocation.types';

export const createVisitLocation = (
   type: VisitLocationType,
   visitLocationData: Omit<VisitLocationData, 'type'>
): VisitLocationData => {
   return {
      id: visitLocationData.id,
      name: visitLocationData.name,
      type: type,
      address: visitLocationData.address,
   };
};

export const createVisitLocationId = (type: VisitLocationType, id: number | undefined): VisitLocationId | undefined => {
   if (!id) {
      return undefined;
   }

   return {
      id: id,
      type: type,
   };
};
